import { useEffect, useState } from "react";

import { Button } from "../../../Components/Buttons";
import { FormInput, FormSection } from "../../../Components/Form";
import { ToastMessage } from "../../../Components/Utils";
import { useFetchLatestContactSettingQuery, useCreateContactSettingMutation } from "../../../stores/api/contactSettings.api";

const EMPTY = { email: "", phone: "", about: "", address: "" };

const ContactSettings = () => {
  const [formData, setFormData] = useState(EMPTY);
  const { data: fetched, isLoading } = useFetchLatestContactSettingQuery();
  const [saveSettings, { isLoading: isSaving }] = useCreateContactSettingMutation();

  useEffect(() => {
    if (fetched) {
      setFormData({
        email: fetched.email || "",
        phone: fetched.phone || "",
        about: fetched.about || "",
        address: fetched.address || "",
      });
    }
  }, [fetched]);

  const setField = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await saveSettings(formData).unwrap();
      ToastMessage({ type: "success", title: "Success", message: "Contact settings saved!" });
    } catch (err) {
      ToastMessage({ type: "error", title: "Error!", message: err?.data?.message || err?.message || "Something went wrong" });
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <span className="w-6 h-6 border-2 border-green-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit} className="mx-auto dark:bg-slate-900 rounded-lg p-6 space-y-5">
        <FormSection title="Contact Information">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormInput
              label="Email" name="email" type="email" value={formData.email} required
              onChange={(val) => setField("email", val)}
              placeholder="contact@example.com"
            />
            <FormInput
              label="Phone" name="phone" value={formData.phone} required
              onChange={(val) => setField("phone", val)}
              placeholder="+1 (555) 000-0000"
            />
            <FormInput
              label="About" name="about" value={formData.about} required
              onChange={(val) => setField("about", val)}
              placeholder="Short description shown on contact page" rows={3}
              className="md:col-span-2"
            />
            <FormInput
              label="Address" name="address" value={formData.address} required
              onChange={(val) => setField("address", val)}
              placeholder="123 Main St, City, Country" rows={3}
              className="md:col-span-2"
            />
          </div>
        </FormSection>

        <div className="flex items-center justify-end gap-3 pt-2">
          <Button
            type="submit" loading={isSaving} disabled={isSaving}
            className="!bg-green-500 !text-white hover:!bg-green-600"
            loadingText="Saving..."
          >
            Save Settings
          </Button>
        </div>
    </form>
  );
};

export default ContactSettings;
